export const BOOK_MODAL = 'bm';
export const LOGIN_MODAL = 'loginModal';
export const SHARE_MODAL = 'shareModal';
export const MARY_MAGIC_SURVEY_MODAL = 'maryMagicSurveyModal';
export const SAVE_SHOW_LOGIN_MODAL = 'save-and-then-show-login';
export const ADD_PROFILE_MODAL = 'add-profile-modal';
export const EDIT_PHARMACY_MODAL = 'edit-pharmacy-modal';
export const CALL_INSURANCE_MODAL = 'call-insurance-modal';
export const COPAY_COINSURANCE_DETAILS_MODAL = 'copay-coinsurance-details-modal';
export const INSURANCE_TUTORIAL_MODAL = 'insurance-tutorial';
export const WEB_PUSH_OPT_IN_MODAL = 'opt-in';
export const INSURANCE_TUTORIAL_ENTRY_POINT_MODAL = 'insurance-tutorial-entry-point';
export const DOWNLOAD_DRIVER_CAROUSEL = 'ddc';
